import styles from './ADSPlayground.module.scss'
import ADSPlaygroundActions from "./Component/ADSPlaygroundActions";
import ADSPlaygroundContent from "./Component/ADSPlaygroundContent";
import {useAIToolsContext} from "../../../../../../context/AIToolsProvider";
import ADSPlaygroundContentActions from "./Component/ADSPlaygroundContentActions";
import {useImageEditorContext} from "../../../../../../context/ImageEditorProvider";
import {useADSContext} from "../../../../../../context/ADSProvider";

const ADSPlayground = () => {
  const {generationError} = useADSContext()
  const {selectedAITools} = useAIToolsContext();
  const {isEditingImage} = useImageEditorContext();

  const hasContentActions = !!selectedAITools || !!isEditingImage

  return (
    <div className={`${styles.wrapper} ${hasContentActions ? styles.aiToolsActive : ''}`}>
      {!generationError && <ADSPlaygroundActions/>}

      {hasContentActions && <ADSPlaygroundContentActions/>}

      <ADSPlaygroundContent/>
    </div>
  );
};

export default ADSPlayground;
